import { createAction } from "redux-actions";

export const updateWorkflow = createAction("UPDATE_WORKFLOW");

export const setWorkflow = payload => {
  return updateWorkflow(payload);
};
